import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/app/wishlist/WishListModule/MobileWishListModule.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/components/AccountsPage/AccountsPage.jsx");
